<p-dialog [(visible)]="display" [style]="{ width: '85vw' }" [blockScroll]="true" [closable]="false" [modal]="true" class="no-padding-top">
    <ng-template pTemplate="header">
        <div class="p-d-flex p-jc-between w-100">
            <h5 class="p-mb-0">
                Bank - {{ selectedBank?.label }} Register
                <span [disabled]="dialogType === 'edit'" class="btnBars p-ml-3" >
                   <liono-treeSelect class="border-bottom-input" [options]="banks" appendTo="body" [(ngModel)]="selectedBank" display="comma" [metaKeySelection]="false" selectionMode="single" (onNodeSelect)="onRowSelectBank($event)"> </liono-treeSelect>
                </span>
            </h5>
            <div class="p-d-flex">
                <span *ngIf="dialogType === 'VIEW' && isEditableViewDialog" class="btnBars" (click)="viewToEditBankRegister()">
                    <i class="pi pi-pencil"></i>
                </span>
                <button pButton pRipple type="button" icon="pi pi-times" (click)="onClose()" class="p-button-rounded p-dialog-header-icon p-dialog-header-close"></button>
            </div>
        </div>
    </ng-template>



    <div class="card">
        <div class="p-grid">
            <div class="p-col-12">
                <p-table [value]="bankRegisters" (onRowSelect)="onRowSelect($event)" selectionMode="single" [(selection)]="selectedRegister" dataKey="id" [resizableColumns]="true" styleClass="p-datatable-gridlines floatthead" #newtable appFloatThead [forceReflow]="showFloatHeader" [showFloatHeader]="showFloatHeader" [floatTableRef]="newtable" floatTableClassRef="floatthead">
                    <ng-template pTemplate="header">
                        <tr>
                            <th pResizableColumn pSortableColumn="createdDate"
                                >Date
                                <p-sortIcon field="createdDate"></p-sortIcon>
                            </th>
                            <th pResizableColumn pSortableColumn="referenceNumber"
                                >No.
                                <p-sortIcon field="referenceNumber"></p-sortIcon>
                            </th>
                            <th pResizableColumn pSortableColumn="txnMemo"
                                >Type.
                                <p-sortIcon field="txnMemo"></p-sortIcon>
                            </th>
                            <th pResizableColumn pSortableColumn="businessName" style="min-width: 200px"
                                >Payee
                                <p-sortIcon field="businessName"></p-sortIcon>
                            </th>
                            <th pResizableColumn pSortableColumn="financialAccountName"
                                >Account
                                <p-sortIcon field="financialAccountName"></p-sortIcon>
                            </th>
                            <th pResizableColumn>Payment</th>
                            <th pResizableColumn class="action" style="width: 2rem">
                                <span class="pi pi-check"></span>
                            </th>
                            <th pResizableColumn>Deposit</th>
                            <th pResizableColumn pSortableColumn="balance"
                                >Balance
                                <p-sortIcon field="balance"></p-sortIcon>
                            </th>
                            <th pResizableColumn style="width: 2rem">
                                <span class="btnBars" (click)="addRegister()" pTooltip="Add New Register" tooltipPosition="top" *ngIf="selectedBank?.id">
                                    <i *ngIf="dialogType != 'VIEW'" class="pi pi-plus"></i>
                                </span>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-bRegister let-rowIndex="rowIndex">
                        <tr [pSelectableRow]="bRegister" [class.child-color2]="rowIndex % 2 != 0">
                            <td>{{ editDetails && editDetails?.accountTransactionMaster && editDetails?.accountTransactionMaster?.length > 0 ? (editDetails?.accountTransactionMaster[0]?.transactionDate | date: "MM/dd/yyyy") : (bRegister?.createdDate | date: "MM/dd/yyyy") }}</td>
                            <td>{{ bRegister?.referenceNumber }}</td>
                            <td>{{ bRegister?.txnMemo }}</td>
                            <td>{{ bRegister?.businessName }}</td>
                            <td>{{ bRegister?.financialAccountName }}</td>
                            <td>{{ bRegister?.isSplitBalance 
                                ? payTo == 'customer' || payTo == 'other' ? splitViewTotalAmount < 0 ? (bRegister?.amount | customNumberFormat: fractionDigits | currencySymbol) :  ""
                                : (bRegister?.amount * -1 | customNumberFormat: fractionDigits | currencySymbol) 
                                : bRegister?.amount >= 0 ? (bRegister?.amount | customNumberFormat: fractionDigits | currencySymbol) : "" }}</td>
                            <td class="action"><span class="pi pi-check" *ngIf="bRegister?.isReconciled"></span></td>
                            <td>{{ bRegister?.isSplitBalance 
                                ?  payTo == 'customer' || payTo == 'other' ? splitViewTotalAmount >= 0 ? (bRegister?.amount | customNumberFormat: fractionDigits | currencySymbol) :  ""
                                : (bRegister?.amount | customNumberFormat: fractionDigits | currencySymbol) : bRegister?.amount < 0 ? (bRegister?.amount * -1 | customNumberFormat: fractionDigits | currencySymbol) : "" }}</td>
                            <td>{{ bRegister?.balance | customNumberFormat: fractionDigits | currencySymbol }}</td>
                            <td></td>
                        </tr>
                    </ng-template>
                    <!-- <ng-template pTemplate="footer">
                        <tr>
                            <td colspan="7" class="p-text-right">Ending Balance</td>
                            <td colspan="2">
                                {{balanceAmt | customNumberFormat: fractionDigits | currencySymbol}}
                            </td>
                        </tr>
                    </ng-template> -->
                </p-table>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <div class="p-mb-3">
            <p-table>
                <ng-template pTemplate="footer">
                    <tr>
                        <td class="p-col-10 p-text-right">Ending Balance</td>
                        <td class="p-col-2">
                            {{ balanceAmt == 0 ? (balanceAmt | customNumberFormat: fractionDigits | currencySymbol) : (balanceAmt * -1 | customNumberFormat: fractionDigits | currencySymbol) }}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <p-button (click)="onClose('cancel')" label="Cancel" styleClass="p-button-secondary"></p-button>
        <p-button (click)="saveBankRegister()" label="Save" *ngIf="dialogType != 'VIEW'" [disabled]="!selectedBank?.id"></p-button>
    </ng-template>
</p-dialog>

<p-dialog [(visible)]="displayAddRegister" [style]="{ width: '60vw' }" [blockScroll]="true" [closable]="false" (onHide)="closeAddRegister()">
    <ng-template pTemplate="header">
        <div class="w-100 p-d-flex">
            <h5 class="p-mb-0">{{ bandRegisterHeader }}</h5>
            <!-- <p-radioButton name="payment" styleClass="p-mx-2" value="payment" [(ngModel)]="pmtOption" [ngModelOptions]="{ standalone: true }" inputId="payment" [disabled]="dialogType === 'VIEW'"></p-radioButton>
            <label for="payment">Payment</label>
            <p-radioButton name="deposit" styleClass="p-mx-2" value="deposit" [(ngModel)]="pmtOption" [ngModelOptions]="{ standalone: true }" inputId="deposit" [disabled]="dialogType === 'VIEW'"></p-radioButton>
            <label for="deposit">Deposit</label> -->
        </div>
        <div *ngIf="statementMessage">
            <strong [ngClass]="'status-open'">{{ statementMessage }}</strong>
        </div>
        <span *ngIf="dialogType === 'VIEW' && !isVoided && isEditableViewDialog" class="btnBars" (click)="viewToEditBankRegister()">
            <i class="pi pi-pencil"></i>
        </span>
        <button pButton pRipple type="button" icon="pi pi-times" (click)="displayAddRegister = false" class="p-button-rounded p-dialog-header-icon p-dialog-header-close"></button>
    </ng-template>
    <form [formGroup]="transactionForm">
        <div class="card">
            <div class="p-grid">
                <div class="p-col-12 p-md-6 p-d-flex">
                    <div class="p-field-radiobutton p-mb-0">
                        <p-radioButton name="vendor" value="vendor" [(ngModel)]="payTo" [ngModelOptions]="{ standalone: true }" inputId="vendor" (onClick)="changePmtOption()" [disabled]="dialogType === 'VIEW'"></p-radioButton>
                        <label for="vendor">Vendor</label>
                    </div>
                    <div class="p-field-radiobutton p-mx-3 p-mb-0">
                        <p-radioButton name="customer" value="customer" [(ngModel)]="payTo" [ngModelOptions]="{ standalone: true }" inputId="customer" (onClick)="changePmtOption()" [disabled]="dialogType === 'VIEW'"></p-radioButton>
                        <label for="customer">Customer</label>
                    </div>
                    <div class="p-field-radiobutton p-mx-3 p-mb-0">
                        <p-radioButton name="employee" value="employee" [(ngModel)]="payTo" [ngModelOptions]="{ standalone: true }" inputId="employee" (onClick)="changePmtOption()" [disabled]="dialogType === 'VIEW'"></p-radioButton>
                        <label for="employee">Employee</label>
                    </div>
                    <div class="p-field-radiobutton p-mx-3 p-mb-0">
                        <p-radioButton name="other" value="other" [(ngModel)]="payTo" [ngModelOptions]="{ standalone: true }" inputId="other" (onClick)="changePmtOption()" [disabled]="dialogType === 'VIEW'"></p-radioButton>
                        <label for="other">Other</label>
                    </div>
                </div>
                <div class="p-col-12 p-md-3">
                    <label>No.</label>
                    <input type="text" pInputText formControlName="lineMemo" />
                </div>
                <div class="p-col-12 p-md-3">
                    <label>Date <span style="color: red">*</span></label>
                    <p-calendar [showIcon]="true" inputId="icon" appendTo="body" formControlName="transactionDate"></p-calendar>
                </div>
            </div>
            <div class="p-grid" *ngIf="payTo == 'vendor'">
                <div class="p-col-12 p-md-6">
                    <label>Vendor <span style="color: red">*</span></label>
                    <p-dropdown [options]="allVendorsDD" [filter]="true" optionLabel="name" placeholder="Select Vendor" appendTo="body" formControlName="vendorId"></p-dropdown>
                </div>
            </div>
            <div class="p-grid" *ngIf="payTo == 'customer'">
                <div class="p-col-12 p-md-6">
                    <label>Channel <span style="color: red">*</span></label>
                    <p-dropdown [options]="accountChannels" optionLabel="name" appendTo="body" [filter]="true" formControlName="accountChannelId" (onChange)="onChangeAccountChannel()"></p-dropdown>
                </div>
                <div class="p-col-12 p-md-6">
                    <label>Account<span style="color: red">*</span></label>
                    <p-autoComplete [suggestions]="allAccountsDD" (completeMethod)="filterAccount($event)" field="nameWithSequenceNumber" [minLength]="1" placeholder="Search Account..." appendTo="body" (onSelect)="selectAccount($event.value)" formControlName="accountId">
                        <ng-template let-account pTemplate="account">
                            <div [ngStyle]="{ 'padding-left.px': account.level * 10 }"> {{ account?.level > 0 ? "-" : "" }} {{ account.nameWithSequenceNumber }} </div>
                        </ng-template>
                    </p-autoComplete>
                </div>
            </div>
            <div class="p-grid" *ngIf="payTo == 'employee'">
                <div class="p-col-12 p-md-6">
                    <label>Employee <span style="color: red">*</span></label>
                    <p-dropdown [options]="allUser" [filter]="true" optionLabel="name" placeholder="Select Employee" appendTo="body" formControlName="employeeId"></p-dropdown>
                </div>
            </div>
            <div class="p-d-flex">
                <div class="p-mr-3">
                    <label>Split</label>
                    <p-checkbox class="p-mt-1" [(ngModel)]="splitAccount" [disabled]="dialogType === 'VIEW'" [binary]="true" inputId="binary" [ngModelOptions]="{ standalone: true }" (ngModelChange)="onSplitAccountChange($event)" />
                </div>
                <div class="p-grid w-100" *ngIf="!splitAccount">
                    <div class="p-col-6">
                        <label>Financial Account <span style="color: red">*</span></label>
                        <liono-treeSelect class="border-bottom-input" formControlName="financialAccount" [options]="financialAccounts" appendTo="body" placeholder="Select Financial Account" display="comma" [metaKeySelection]="false" selectionMode="single"></liono-treeSelect>
                    </div>
                    <div class="p-col-3">
                        <label>{{ "Payment" }}</label>
                        <div style="align-items: center">
                            <p-inputNumber mode="decimal" formControlName="paymentAmount" [min]="0" [minFractionDigits]="fractionDigits" [maxFractionDigits]="fractionDigits"></p-inputNumber>
                        </div>
                    </div>
                    <div class="p-col-3">
                        <label>{{ "Deposit" }}</label>
                        <div style="align-items: center">
                            <p-inputNumber mode="decimal" formControlName="depositAmount" [min]="0" [minFractionDigits]="fractionDigits" [maxFractionDigits]="fractionDigits"></p-inputNumber>
                        </div>
                    </div>
                </div>
                <ng-container *ngIf="splitAccount">
                    <div formArrayName="transactions" class="w-100">
                        <div class="p-grid">
                            <div class="p-col-4 p-pb-0">
                                <label>Financial Account <span style="color: red">*</span></label>
                            </div>
                            <div class="p-col-2 p-pb-0">
                                <label>Amount <span>($)</span></label>
                            </div>
                            <div class="p-col-6 p-pb-0 p-d-flex p-jc-between">
                                <label>Memo</label>
                                <div *ngIf="splitViewTotalAmount == 0">Total: {{ splitViewTotalAmount }}</div>
                                <div *ngIf="splitViewTotalAmount > 0"> {{ payTo == 'customer'  ? 'Deposit' : 'Payment'}} Total: {{ splitViewTotalAmount }}</div>
                                <div *ngIf="splitViewTotalAmount < 0"> {{ payTo == 'customer'  ? 'Payment' : 'Deposit'}} Total: {{ splitViewTotalAmount * -1 }}</div>
                            </div>
                        </div>
                        <div class="p-grid" *ngFor="let entry of transactions.controls; let i = index" [formGroupName]="i">
                            <div class="p-col-4">
                                <liono-treeSelect class="border-bottom-input" [options]="financialAccounts" appendTo="body" placeholder="Select Financial Account" display="comma" formControlName="financialAccountId" [metaKeySelection]="false" selectionMode="single"></liono-treeSelect>
                            </div>
                            <div class="p-col-2">
                                <p-inputNumber mode="decimal" [minFractionDigits]="fractionDigits" [maxFractionDigits]="fractionDigits" formControlName="amount" styleClass="w-100" (onInput)="calculateSplitViewTotalAmount()"></p-inputNumber>
                            </div>
                            <div class="p-col-6 p-d-flex p-jc-between">
                                <input type="text" pInputText class="w-100" formControlName="transactionsmemo" />
                                @if (i == 0) {
                                    <span *ngIf="dialogType != 'VIEW'" class="btnBars" (click)="addTransaction(i)" pTooltip="Add" tooltipPosition="top" style="margin-left: 8px">
                                        <i class="pi pi-plus"></i>
                                    </span>
                                } @else if (i > 0) {
                                    <span *ngIf="dialogType != 'VIEW'" class="btnBars" (click)="removeTransaction(i)" pTooltip="Remove" tooltipPosition="top" style="margin-left: 8px">
                                        <i class="pi pi-minus"></i>
                                    </span>
                                }
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
            <div *ngIf="transactionForm?.errors?.bothAmountsEntered && (transactionForm.get('paymentAmount')?.dirty || transactionForm.get('depositAmount')?.dirty) && !splitAccount" style="color: red"> Only one of Payment or Deposit can be entered. </div>
            <div *ngIf="transactionForm?.errors?.noAmountEntered && (transactionForm.get('paymentAmount')?.touched || transactionForm.get('depositAmount')?.touched) && !splitAccount" style="color: red"> Either Payment or Deposit must be entered. </div>
            <div *ngIf="transactionForm?.errors?.amountCannotBeZero && (transactionForm.get('paymentAmount')?.touched || transactionForm.get('depositAmount')?.touched) && !splitAccount" style="color: red"> The amount cannot be zero. </div>
            
            <!-- <div *ngIf="transactionForm?.errors?.transactionAmountMismatch" style="color: red;">
                Transaction amount must exactly match the specified amount {{ transactionForm.value.paymentAmount || transactionForm.value.depositAmount }}.
            </div> -->

            <div class="p-grid">
                <div class="p-col-12">
                    <label>Memo</label>
                    <input type="text" pInputText formControlName="memo" />
                </div>
            </div>
            <div class="p-grid p-mt-3" *ngIf="isAllowPostingPeriod">
                <div class="p-col-6">
                    <label class="p-mr-2">Posting Period:<span style="color: red">*</span></label>
                    <app-posting-period-selector 
                        [transactionDate]="transactionForm?.get('transactionDate')?.value"
                        [selectedPostingPeriod]="currentPostingPeriodInfo" [moduleName]="'Bank Register'"
                        [isViewMode]="dialogType === 'VIEW'"
                        (postingInfoChange)="onPostingInfoChange($event)">
                    </app-posting-period-selector>
                </div>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button *ngIf="dialogType == 'VIEW' && isShowVoidDelete" type="button" pButton label="Void" [disabled]="isVoided" (click)="voidOrDelete(true)" class="p-mr-2"></button>
        <p-button *ngIf="dialogType == 'VIEW' && isShowVoidDelete" [label]="'Delete'" (click)="voidOrDelete(false)" styleClass="p-button-danger" class="p-mr-2"></p-button>
        <p-button label="Cancel" (click)="closeAddRegister()" styleClass="p-button-secondary"></p-button>
        <p-button *ngIf="dialogType !== 'VIEW'" label="Save" (click)="saveTransaction()" [disabled]="(isAllowPostingPeriod && !updatedPostingPeriodInfo?.postingDate) || isSaveButtonDisabled || !!statementMessage"></p-button>
        <ng-container *ngIf="dialogType !== 'VIEW'">
            <p-button *ngIf="dialogType !== 'edit'" label="Save & New" (click)="saveAndNewTransaction()" [disabled]="(isAllowPostingPeriod && !updatedPostingPeriodInfo?.postingDate) || isSaveButtonDisabled || !!statementMessage"></p-button>
        </ng-container>
    </ng-template>
</p-dialog>

<p-dialog header="Undeposited Funds" [(visible)]="displayUndepositedFunds" [style]="{ width: '60vw' }" [blockScroll]="true">
    <div class="card">
        <app-undeposited-funds [depositId]="selectedRegister?.txnId"></app-undeposited-funds>
    </div>
    <ng-template pTemplate="footer">
        <p-button (click)="displayUndepositedFunds = false" label="Cancel" styleClass="p-button-secondary"></p-button>
        <p-button label="Save"></p-button>
    </ng-template>
</p-dialog>

<!-- make deposit view-->
<app-make-deposit *ngIf="displayMakeDepositViewDialog" [display]="displayMakeDepositViewDialog" [dialogType]="'VIEW'" [depositId]="selecteddepositId" [type]="'VIEW'" (close)="onCloseMakeDepositViewDialog($event)"></app-make-deposit>
<!-- Fund transfer view-->
<app-transfer-funds *ngIf="displayFundTransfer" [display]="displayFundTransfer" [dialogType]="fundTransferDialogType" [transferFundId]="selectedtransferFundId" (close)="onCloseFundTransfer($event)"></app-transfer-funds>

<app-write-check *ngIf="displayWriteCheck" [display]="displayWriteCheck" [checkId]="selectedRegister?.txnId" [checkDialogType]="checkDialogType" (close)="closeWriteCheck()"></app-write-check>

<!-- invoice  popup  -->
<app-inventory-module-overview-dialogs *ngIf="displayInventoryOverview" [displayOverview]="displayInventoryOverview" [overviewRefId]="inventoryOverviewRefId" [overviewRefNumber]="inventoryOverviewRefNumber" [overviewModule]="inventoryOverviewModule" [isShowVoidDelete]="true" (onCancel)="closeViewPopup()"> </app-inventory-module-overview-dialogs>

<app-add-expense *ngIf="displayAddEditExpense && overviewRefId" [displayAddEditExpense]="displayAddEditExpense" [expenseId]="overviewRefId" [type]="'VIEW'" (close)="onCloseExpenseDialog($event)"> </app-add-expense>

<!-- closing statement -->
<ng-container *ngIf="displayAddRegister">
    <app-closing-statement-validation
        [isClosingDate]="isAllowPostingPeriod ? (updatedPostingPeriodInfo?.postingDate ?? currentPostingPeriodInfo?.postingDate ?? null) : transactionForm?.controls?.transactionDate.value" 
        [moduleName]="'Bank Register'" (isClosingStatementDate)="isClosingStatementDate($event)"> 
    </app-closing-statement-validation>
</ng-container>
